module.exports = __webpack_public_path__ + "static/media/flying-kite.60bb2148.svg";